"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ParsedDesc_1 = require("./ParsedDesc");

var PropDesc =
/*#__PURE__*/
function (_ParsedDesc_1$ParsedD) {
  _inherits(PropDesc, _ParsedDesc_1$ParsedD);

  function PropDesc(parser, description) {
    var validators = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : immutable_1.List.of();

    _classCallCheck(this, PropDesc);

    return _possibleConstructorReturn(this, _getPrototypeOf(PropDesc).call(this, parser, description, validators));
  }

  _createClass(PropDesc, [{
    key: "withMappedParser",
    value: function withMappedParser(spec, mapping) {
      if (this.parser instanceof spec) {
        return new PropDesc(mapping(this.parser), this.description, this.validators);
      } else {
        return this;
      }
    }
  }, {
    key: "withDescription",
    value: function withDescription(descr) {
      return new PropDesc(this.parser, this.mergeDescs(descr), this.validators);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitProp(this);
    }
  }]);

  return PropDesc;
}(ParsedDesc_1.ParsedDesc);

exports.PropDesc = PropDesc;